/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Link from 'next/link';
import http from "utilities/http";
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG } from "framework/store/constants";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import isEmpty from "lodash/isEmpty";
import FilterComponent from 'components/tao-bai-viet/bo-loc/filterComponent';
import TagComponent from 'components/tao-bai-viet/tag/tagComponent';
import EditorComponent from 'components/tao-bai-viet/noi-dung/editorComponent';
import { toast } from 'react-toastify';
import StarList from 'components/shop/review/starList';

export default function Index({ modalDanhGiaDisplay, setModalDanhGiaDisplay, professional }) {
    const onHideModal = () => {
        setModalDanhGiaDisplay(false);
        setShowSearch(false);
    };

    //----------------------------------Tìm kiếm----------------------------------
    const [searchValue, setSearchValue] = useState(professional.display_name);
    const [proList, setProList] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [selectedPro, setSelectedPro] = useState(professional);
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(null);
    const [isDisable, setIsDisabled] = useState(false);

    const fetchChuyenGia = async (page) => {
        page = page || 1;
        const url = searchValue != ''
            ? `community/search/professional?per_page=0&page=${page}&keyword=` + searchValue
            : `community/professional?per_page=15&page=${page}`;

        const response = await http(url, null, {}, 'v2');
        if (response.code == 200) {
            setProList(response.data);
        }
    };
    useEffect(() => {
        fetchChuyenGia();
    }, [searchValue]);
    const timKiemChuyenGia = <>
        <label className="createPost-label">Tìm kiếm chuyên gia</label>
        <div className="createPost-search">
            <button className="btn btn--search"><img src="/images/icon-search.svg" alt="" /></button>
            <input className="form-control" type="text" placeholder="Nhập tên chuyên gia" data-toggle="dropdown" value={searchValue}
                onClick={() => setShowSearch(true)}
                // onKeyUp={(e) => {
                //     if (e.key === 'Enter' || e.keyCode === 13) {
                //         setSearchValue(e.target.value);
                //     }
                // }}
                onChange={(e) => setSearchValue(e.target.value)}
            />
            <div className={"dropdown-menu" + (showSearch ? ' show' : '')}>
                <div className="list-experts">
                    <ul>
                        {proList.map((item, index) => {
                            return <li key={index}>
                                <div className="photoStore-head">
                                    <div className="photoStore-head__item">
                                        <img src={item?.avatar || '/images/icon-app.svg'} alt="" />
                                    </div>
                                    <div className="photoStore-head__text">
                                        <p className="tlt">{item?.display_name}</p>
                                        <p className="lable">
                                            {(!isEmpty(item?.field) ? item?.field?.name : '')
                                                + ((!isEmpty(item?.job_title && item?.job_title?.name != 'Khác') ? (' -  ' + item?.job_title?.name) : ''))}
                                        </p>
                                    </div>
                                    <button className="btn btn--blue" onClick={() => {
                                        setShowSearch(false);
                                        setSearchValue(item?.display_name);
                                        setSelectedPro(item);
                                    }}>Chọn</button>
                                </div>
                            </li>;
                        })
                        }
                    </ul>
                </div>
                {
                    isEmpty(proList) && searchValue != "" && searchValue != null && <div className="notFound">
                        <p className="notFound-txt">Không tìm thấy chuyên gia</p>
                        <p className="notFound-lable">“{searchValue}”</p>
                    </div>
                }
            </div>
        </div>
    </>;

    //----------------------------------Mức độ hài lòng----------------------------------
    const [rating, setRating] = useState(5);
    const mucDoHaiLong = <>
        <label className="createPost-label">Mức độ hài lòng với chuyên gia</label>
        <StarList number={rating} size={24} onClickFunc={(num) => setRating(num)}/>
    </>;

    //----------------------------------Filter information----------------------------------
    const [state, _setState] = useState({
        title: '',
        tenNgoiNha: null,
        dienTich: null,
        dienTichXayDung: null,
        chieuNgang: null,
        chieuDoc: null,
        nganSachXayTho: null,
        nganSachHoanThien: null,
        thumbnail_file_id: null,

        loaiNha: [],
        loaiNhaOps: [],
        phongCach: [],
        phongCachOps: [],
        tinhThanhPho: [],
        tinhThanhPhoOps: []
    });
    const setState = (_state) => {
        _setState((state = {}) => ({
            ...state,
            ..._state
        }));
    };

    const fetchFilter = async () => {
        const res = await http(`community/article/filter/561?per_page=20`, {}, {}, 'v2');
        if (res.code == 200) {
            setState({ loaiNhaOps: res.data.find(x => x.slug == 'loai-nha').terms });
            setState({ phongCachOps: res.data.find(x => x.slug == 'phong-cach').terms });
            setState({ tinhThanhPhoOps: res.data.find(x => x.slug == 'khu-vuc').terms });
        }
    };
    useEffect(() => {
        fetchFilter();
    }, []);

    const thongTinNgoiNha = <ul>
        <li>
            <label className="createPost-label">Thông tin ngôi nhà</label>
            <div className="createPost-select">
                <input className="form-control" type="text" placeholder="Tên ngôi nhà (nếu có)" value={state.tenNgoiNha} onChange={e => setState({ tenNgoiNha: e.target.value })} />
            </div>
            <FilterComponent
                title="Loại nhà"
                options={state.loaiNhaOps}
                oldSelected={state.loaiNha}
                set={(selecteds) => setState({ loaiNha: selecteds })} />
            <FilterComponent
                title="Phong cách"
                options={state.phongCachOps}
                oldSelected={state.phongCach}
                set={(selecteds) => setState({ phongCach: selecteds })} />

            <label className="createPost-label">Vị trí địa lý</label>
            <FilterComponent
                title="Tỉnh/Thành phố"
                options={state.tinhThanhPhoOps}
                oldSelected={state.tinhThanhPho}
                set={(selecteds) => setState({ tinhThanhPho: selecteds })} />
        </li>

        <li>
            <label className="createPost-label">Diện tích ngôi nhà</label>
            <div className="createPost-select">
                <input className="form-control" type="number" placeholder="Diện tích mặt bằng (m2)" value={state.dienTich} onChange={e => setState({ dienTich: e.target.value })} />
            </div>
            <div className="createPost-select">
                <ul className="createPost-col">
                    <li>
                        <input className="form-control" type="number" placeholder="Chiều ngang (m)" value={state.chieuNgang} onChange={e => setState({ chieuNgang: e.target.value })} />
                    </li>
                    <li>
                        <input className="form-control" type="number" placeholder="Chiều dọc (m)" value={state.chieuDoc} onChange={e => setState({ chieuDoc: e.target.value })} />
                    </li>
                </ul>
            </div>
            <div className="createPost-select">
                <input className="form-control" type=" number" placeholder="Tổng diện tích xây dựng (nếu có) (m2)" value={state.dienTichXayDung} onChange={e => setState({ dienTichXayDung: e.target.value })} />
            </div>

            <label className="createPost-label">Tổng ngân sách</label>
            <div className="createPost-select">
                <input className="form-control" type="number" placeholder="Ngân sách xây thô (đồng)" value={state.nganSachXayTho} onChange={e => setState({ nganSachXayTho: e.target.value })} />
            </div>
            <div className="createPost-select">
                <input className="form-control" type="number" placeholder="Ngân sách hoàn thiện (đồng)" value={state.nganSachHoanThien} onChange={e => setState({ nganSachHoanThien: e.target.value })} />
            </div>
        </li>
    </ul>;


    //----------------------------------Bài viết----------------------------------
    const [content, setContent] = useState([]);
    const vietBai = <div>
        <EditorComponent contentParent={content} thumbnail_file_id={state.thumbnail_file_id} setState={setState} setContentParent={setContent} />
    </div>;

    //----------------------------------Tạo tag----------------------------------
    const [tags, setTags] = useState([]);
    const taoTag = <TagComponent oldSelected={tags} set={setTags} />;

    //----------------------------------Đăng bài---------------------------------
    const submit = async () => {
        setIsDisabled(true);
        try {

            const body = {};

            // Review
            body.title = state.title;
            body.reviewer_type = 1;
            body.reviewer_id = selectedPro.id;
            body.rating = rating;

            //Term
            const listTerms = state.loaiNha.concat(state.phongCach).concat(state.tinhThanhPho);
            body.term_ids = listTerms;

            //Information
            const information = {
                house_name: state.tenNgoiNha,
                area: {
                    width: state.chieuNgang,
                    length: state.chieuDoc,
                    real: state.dienTich,
                    total: state.dienTichXayDung
                },
                budget: {
                    raw: state.nganSachXayTho,
                    finishing: state.nganSachHoanThien
                },
            };
            if (!(information.house_name || Object.values(information.area).some(x => x !== null && x !== '') || Object.values(information.budget).some(x => x !== null && x !== ''))) {
                body.information = null;
            } else {
                body.information = information;
            }

            //Tag
            body.tags = tags.map(x => x.id);

            //Image + Content
            let contentText = '';
            const images = [];

            content.forEach((item) => {
                contentText = contentText + item.content;
                item.image.forEach(img => {
                    contentText = contentText
                        + `<img style="display: block; margin-left: auto; margin-right: auto; width: 100%; height: auto" src="${img.storage_url}" />`;
                });
                images.push(...item.image.map(x => x.id));
            });
            body.content = contentText;
            body.images = images;

            //Check Info

            const res = await http('community/me/reviews', {}, {
                body: body,
                method: 'POST',
                token: 'Bearer ' + getCookie(TOKEN_CONGDONG)
            }, 'v2');

            if (res.code === 200) {
                setIsShowModalConfirm({
                    id: res.data?.id || res.id || res.photo?.data?.id,
                });

            };
            if (res.code !== 200) {
                if (!res.errors) {
                    toast.error('Đã có lỗi xảy ra, vui lòng thử lại.');
                    return;
                }
                const errors = res.errors;
                toast.error(errors || 'Đã có lỗi xảy ra, vui lòng thử lại.');
            };
        } catch (e) {
            console.log(e);
        } finally {
            setIsDisabled(false);
        }
    };

    const transfer = () => {
        setIsShowModalConfirm(false);
        setModalDanhGiaDisplay(false);
        setContent([]);
        setTags([]);
        setRating(5);
        setState({
            title: '',
            tenNgoiNha: null,
            dienTich: null,
            dienTichXayDung: null,
            chieuNgang: null,
            chieuDoc: null,
            nganSachXayTho: null,
            nganSachHoanThien: null,
            thumbnail_file_id: null,

            loaiNha: [],
            loaiNhaOps: [],
            phongCach: [],
            phongCachOps: [],
            tinhThanhPho: [],
            tinhThanhPhoOps: []
        });
    };

    return (
        <>
            <Modal show={modalDanhGiaDisplay} onHide={onHideModal} role="document" className="modal-photo-posts" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Tạo đánh giá chuyên gia
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <section className="main main--createPost mt-0">
                        <div className="wrap">
                            <div className="wrap-content">
                                <div className="createPost-box">
                                    <div className="createPost-title" style={{ position: 'relative' }}>
                                        <Button variant="primary" disabled={isDisable} className="" style={{ position: 'absolute', right: 0 }} onClick={submit} >
                                            Đăng bài
                                        </Button>
                                        <h2 className="title">Thông tin chung</h2>
                                    </div>
                                    <div className="createPost-lst">
                                        <ul>
                                            <li className="w-100">
                                                {timKiemChuyenGia}
                                                {selectedPro && <div className="photoStore-head mt-3">
                                                    <div className="photoStore-head__item" style={{ width: 70, height: 70 }}>
                                                        <img alt="" src={selectedPro.avatar || '/images/icon-app.svg'} />
                                                    </div>
                                                    <div className="photoStore-head__text" style={{ width: 'calc(100% - 100px)' }}>
                                                        <p className="tlt">{selectedPro.display_name}</p>
                                                        <p className="lable">
                                                            {(!isEmpty(selectedPro?.field) ? selectedPro?.field?.name : '')
                                                                + ((!isEmpty(selectedPro?.job_title && selectedPro?.job_title?.name != 'Khác') ? (' -  ' + selectedPro?.job_title?.name) : ''))}
                                                        </p>
                                                        {/* <p className="lable">{article.review_data?.infoProfessional}</p> */}
                                                    </div>
                                                </div>}
                                                {mucDoHaiLong}
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="createPost-lst">
                                        {thongTinNgoiNha}
                                    </div>
                                </div>

                                <div className="createPost-box">
                                    <div className="createPost-title">
                                        <h2 className="title">Viết bài</h2>
                                        <hr />
                                    </div>
                                    <div className="createPost-edit mt-1">
                                        <p style={{ fontWeight: 500 }}>Tiêu đề <span style={{ color: 'red' }}>*</span></p>
                                        <input className="form-control" type="text" placeholder="Nhập tiêu đề bài viết tối đa 100 kí tự" value={state.title}
                                            onChange={(e) => setState({ title: e.target.value })}
                                            style={{
                                                borderTop: 'none',
                                                borderRight: 'none',
                                                borderLeft: 'none',
                                                borderRadius: 0,
                                                padding: 0,
                                                fontSize: 16
                                            }} />
                                        <p style={{ fontWeight: 500, color: '#aaa', textAlign: 'right', fontSize: '12px' }}>{state.title.length}/100</p>
                                        {vietBai}
                                        {taoTag}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {
                        (showSearch) &&
                        <div className="backdrop"
                            onClick={() => setShowSearch(false)}>
                        </div>
                    }
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={onHideModal} >
                        Hủy
                    </Button>
                    <Button variant="primary" onClick={() => { }} >
                        Đăng
                    </Button>
                </Modal.Footer> */}
            </Modal>

            <Modal show={!!isShowModalConfirm}>
                <Modal.Header>
                    <Modal.Title>Thông báo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Bài đánh giá chuyên gia của bạn đã được chuyển đến Hệ thống để kiểm duyệt. Chúng tôi sẽ kiểm tra và thông báo cho bạn sớm nhất có thể.</p>
                    <p>Xem thêm <a href="/trung-tam-tro-giup/100000020/huong-dan-dang-bai-viet-va-nhan-diem-thuong" target="_blank">Hướng dẫn đăng bài viết và nhận điểm thưởng</a></p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={transfer}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}